import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { MESSAGES } from "../../../utlis/messages";

const GET_INVOICE_LIST = `invoiceMapping`;
const GET_INVOICE_DETAIL_LIST = `invoiceMapping/details`;

const GET_INVOICE_HEADERS = `invoiceMapping/mappedHeaders`;
const ADD_MAPPING_HEADERS = `invoiceMapping/addMappingHeaders`;
const UPLOAD_CSV = `invoiceMapping/uploadCsv`;
const UPLOAD_DOCUMENT = `invoiceMapping/uploadDocuments`;

const DOWNLOAD_CSV = `inventory/downloadCsv`;
const UPDATE_INVOICE = `invoiceMapping/update`;
const ADD_DOCUMENT_DATA = `invoiceMapping/storeUploadData`;


export const FetchInvoiceList = createAsyncThunk(
  "FetchInvoiceList",
  async ({ page, limit, search = "", fromDate = "", toDate = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_INVOICE_LIST}?page=${page}&limit=${limit}&search=${search}&fromDate=${fromDate}&toDate=${toDate}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

// details
export const FetchInvoiceDetailList = createAsyncThunk(
  "FetchInvoiceDetailList",
  async ({ invoice_number, page = 1, limit = 10 }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).get(
        `${GET_INVOICE_DETAIL_LIST}?invoice_number=${invoice_number}&page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG);
      return rejectWithValue(error.response?.data);
    }
  }
);



export const uploadInvoiceCsv = createAsyncThunk(
  "uploadInventoryCsv",
  async (data: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(UPLOAD_CSV, data);
      const payload = response.data;

      const inserted = payload?.data?.inserted || 0;
      const failed = payload?.data?.failed || 0;

      if (failed === 0) {
        successMessage(`${inserted} riga(e) caricate con successo.`);
      }
      dispatch(FetchInvoiceList({ page: 1, limit: 10 }))

      return payload;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addInvoiceHeaders = createAsyncThunk(
  "addInvoiceHeaders",
  async (data: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(ADD_MAPPING_HEADERS, data);
      // successMessage(response.data.responseMessage)
      dispatch(FetchInvoiceList({ page: 1, limit: 10 }))
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const FetchInvoiceHeaders = createAsyncThunk(
  "FetchInvoiceHeaders",
  async ({ }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_INVOICE_HEADERS}`);
      return response.data.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

// delete invoice

export const DeleteInvoice = createAsyncThunk(
  "DeleteInvoice",
  async ({ id, selectedPage, invoice_number }: { id: string; selectedPage: any, invoice_number: string }, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).delete(`${GET_INVOICE_LIST}/${id}`);
      successMessage("Inventory deleted successfully");
      await dispatch(FetchInvoiceDetailList({
        invoice_number,
        page: 1,
        limit: 10,
      }));
      await dispatch(FetchInvoiceList({ page: 1, limit: 10 }));


      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

// update invoice
export const updateInvoice = createAsyncThunk(
  "updateInvoice",
  async ({ values }: any, { rejectWithValue, dispatch }) => {
    try {
      const id = values.id;

      const {
        quantity,
        price,
        description,
        production_lot,
        currency,
        expected_delivery_date,
        invoice_date,
        isExported,
        number_of_box,
        gross_weight,
        net_weight,
        bill_lading_number,
        shipping_mode
      } = values;

      const response = await customAxios("application/json", dispatch).put(
        `${UPDATE_INVOICE}/${id}`,
        {
          quantity,
          price,
          description,
          production_lot,
          currency,
          expected_delivery_date,
          invoice_date,
          isExported,
          number_of_box,
          gross_weight,
          net_weight,
          bill_lading_number,
          shipping_mode
        }
      );

      successMessage(response.data?.payload?.responseMessage || MESSAGES.INVENTORY_UPDATED);

      await dispatch(
        FetchInvoiceDetailList({
          invoice_number: values.invoice_number,
          page: 1,
          limit: 10,
        })
      );
      await dispatch(FetchInvoiceList({ page: 1, limit: 10 }));

      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG);
      return rejectWithValue(error.response.data);
    }
  }
);

export const DownloadInvoiceList = createAsyncThunk(
  "DownloadInvoiceList",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${DOWNLOAD_CSV}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const uploadInvoiceDocuments = createAsyncThunk(
  "uploadInvoiceDocuments",
  async (formData: FormData, { rejectWithValue, dispatch }) => {
    try {
      // Note: Do NOT set Content-Type manually for FormData; the browser sets the correct boundary
      const response = await customAxios(undefined, dispatch).post(UPLOAD_DOCUMENT, formData);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || "Something went wrong");
      return rejectWithValue(error?.response?.data);
    }
  }
);

// fetch invoice documents by invoice number
export const FetchInvoiceDocuments = createAsyncThunk(
  "FetchInvoiceDocuments",
  async ({ invoice_number }: { invoice_number: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).get(
        `invoiceMapping/documents/${invoice_number}`
      );
      return response.data; 
    } catch (error: any) {
      // errorMessage(
      //   error?.response?.data?.responseMessage || "Failed to fetch invoice documents"
      // );
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const storeInvoiceDocumentData = createAsyncThunk(
  "storeInvoiceDocumentData",
  async (data: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(ADD_DOCUMENT_DATA, data);
      // successMessage(response.data.responseMessage)
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);